import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export type CollectedFeeStatus = "PENDING" | "DEDUCTED" | "INVOICED" | "SETTLED" | "WAIVED" | "FAILED" | "REFUNDED";

export interface CollectedFee {
  id                  : string;
  tenantId            : string;
  orderId             : string;
  orderNumber         : string | null;
  paymentId           : string | null;
  endCustomerBusinessId: string;
  baseAmount          : string;
  baseCurrency        : string;
  calculationMethod   : "PERCENTAGE" | "FLAT" | "TIERED";
  appliedRate         : string | null;
  appliedFlatAmount   : string | null;
  appliedTier         : object | null;
  calculatedFeeAmount : string;
  minApplied          : boolean;
  maxApplied          : boolean;
  finalFeeAmount      : string;
  feeCurrency         : string;
  status              : CollectedFeeStatus;
  refundPolicySnapshot: "PRO_RATA" | "NONE" | "FULL_ONLY";
  collectedAt         : string;
  reversedAt          : string | null;
  reversedAmount      : string | null;
  reversalReason      : string | null;
}

export interface ListParams {
  status?: CollectedFeeStatus;
  customerId?: string;
  orderNumber?: string;
  fromDate?: string;
  toDate?: string;
  page?: number;
  limit?: number;
}

export const list = (params?: ListParams) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.get("/bil/my/collected-fees", params as any);

export const get = (id: string) => httpRequest.get(`/bil/my/collected-fees/${id}`);
